import utils from '../../utils/index.js'
import tools from '../../utils/tools' //../../utils/tools.js

/**
 * @description: 微信显示授权
 * @param {*} params
 * @return {*}
 */
function strongAuth(params) {
  // 测试=
  // return
  // 测试=
  let appId = utils.config.config.appId
  // let redirect_uri = window.location.href
  let redirect_uri = params.redirect_uri
  console.log('wxtools-授权回调地址:', window.location.href)
  console.log('wxtools-授权回调地址:', redirect_uri)
  let wx_link =
    'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
    encodeURIComponent(appId) +
    '&redirect_uri=' +
    encodeURIComponent(redirect_uri) +
    '&response_type=code&scope=snsapi_userinfo&state=STATE&forcePopup=true#wechat_redirect'

  window.location.href = wx_link
}
/**
 * 获取微信code
 *
 * @returns
 */
let code = ''
function getWxCode() {
  return new Promise((resolve, reject) => {
    // 静默授权-获取code
    code = tools.getQueryString('code')
    let callback = ''
    let appId = utils.config.config.appId
    let redirect_uri = window.location.origin + window.location.pathname
    let wx_link =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
      appId +
      '&redirect_uri=' +
      redirect_uri +
      '&response_type=code&scope=snsapi_userinfo#wechat_redirect'

    if (!code || code == null) {
      window.location.href = wx_link
      code = tools.getQueryString('code')

      // if (code) {
      resolve(code)
      // }
    } else {
      reject(code)
    }
  })
}

/**
 *  根据code获取openId
 *
 * @param {*} code
 */
function getOpenId(code, token) {
  return new Promise((resole, reject) => {
    this.$http
      .get(utils.urls.snsUser, {
        params: {
          code: code
        },
        headers: {
          xfrom: utils.config.config.xfrom,
          token: token
        }
      })
      .then((res) => {
        resole(res)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

function initShare(shareObj) {
  console.log('initShare-分享参数--', shareObj)
  let _shareObj = shareObj || {}
  // 获取签名
  this.$http
    .get(utils.urls.jsapiSign, {
      params: {
        //签名url
        url: _shareObj.referer.split('#')[0],
        appid: _shareObj.appId
      },
      headers: {}
    })
    .then((res) => {
      // 签名成功
      if (res.data.success) {
        console.log('获取签名结果', res)
        let jsapi = res.data.data
        wx.config({
          // debug: _shareObj.debug || true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: jsapi.appId, // 必填，公众号的唯一标识
          timestamp: jsapi.timestamp, // 必填，生成签名的时间戳
          nonceStr: jsapi.nonceStr, // 必填，生成签名的随机串
          signature: jsapi.signature, // 必填，签名
          // 必填，需要使用的JS接口列表
          jsApiList: [
            'checkJsApi',
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'openAddress'
          ]
        })

        // 分享内容
        let _shareParams = {
          title: _shareObj.title,
          desc: _shareObj.desc,
          link: _shareObj.link,
          imgUrl: _shareObj.imgUrl,

          // 分享地址不带hash，
          //  link: 'https://static.xueliyingyu.com/fe/prod/fission/friend.html?reqId=132256220455272448&saleItem=XY132148035091334144',

          // 分享地址是正确的，
          // link: 'https://static.xueliyingyu.com/fe/prod/fission/index.html#/friend?reqId=132256220455272448&saleItem=XY132148035091334144',
          // imgUrl: 'https://static.xueliyingyu.com/h5/img/icons/birth.png',
          // imgUrl: 'https://static.xueliyingyu.com/h5/img/background.png',
          type: shareObj.type || '', // 分享类型,music、video或link，不填默认为link
          dataUrl: shareObj.dataUrl || '' // 如果type是music或video，则要提供数据链接，默认为空
        }
        console.log('_shareParams', _shareParams)
        // 设置回调
        if (_shareObj.success) {
          _shareParams.success = _shareObj.success
        }
        if (_shareObj.cancel) {
          _shareParams.cancel = _shareObj.cancel
        }
        if (_shareObj.fail) {
          _shareParams.fail = _shareObj.fail
        }
        // config成功后执行wx.ready
        wx.ready(function () {
          // 判断当前客户端版本是否支持指定JS接口，客户端6.7.2及JSSDK 1.4.0以上版本使用分享新接口
          let _newApi = {}

          wx.checkJsApi({
            jsApiList: [
              'checkJsApi',
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'onMenuShareTimeline',
              'onMenuShareAppMessage',
              'onMenuShareQQ',
              'onMenuShareWeibo',
              'onMenuShareQZone',
              'openAddress'
            ],
            success: function (res) {
              _newApi = res.checkResult
              console.log('_newApi2', _newApi)
              //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
              if (_newApi.updateAppMessageShareData) {
                console.log('分享1-1.7')
                wx.updateAppMessageShareData(_shareParams)
              } else {
                console.log('分享2')
                // 分享给朋友
                wx.onMenuShareAppMessage(_shareParams)
                // 分享到QQ
                wx.onMenuShareQQ(_shareParams)
              }
              // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0
              if (_newApi.updateTimelineShareData) {
                console.log('分享3')
                wx.updateTimelineShareData(_shareParams)
              } else {
                console.log('分享4')
                //分享到朋友圈
                wx.onMenuShareTimeline(_shareParams)
                //分享到QQ空间
                wx.onMenuShareQZone(_shareParams)
              }
              wx.onMenuShareWeibo(_shareParams)
            }
          })
          console.log('_newApi1', _newApi)
        })

        wx.error((error) => {
          console.log('config error->', res)
          if (shareObj.fail) {
            shareObj.fail({ errMsg: 'config error' })
          }
        })
      }
    })
    .then((error) => {
      console.log('签名错误->', error)
      if (shareObj.fail) {
        shareObj.fail({ errMsg: 'sigin error' })
      }
    })
}
/**
 * @description: 禁止微信分享
 * @param {*}
 * @return {*}
 */
function wxshareNO() {
  var vm = this
  if (typeof WeixinJSBridge == 'undefined') {
    //微信浏览器内置对象。参考微信官方文档
    if (document.addEventListener) {
      try {
        document.addEventListener(
          'WeixinJSBridgeReady',
          vm.onBridgeReady(),
          false
        )
      } catch {
        console.log('')
      }
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady())
      document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady())
    }
  } else {
    onBridgeReady()
  }

  console.log('成功执行wxShareNo-wxtools')
}
function onBridgeReady() {
  WeixinJSBridge.call('hideOptionMenu')
}

export default {
  getWxCode,
  getOpenId,
  initShare,
  wxshareNO,
  strongAuth
}
